import firmware from '@/upgrade/firmware'
import { compare } from 'compare-versions'
import { DevicePid } from './define'
import { JingTaiV2DeviceList, JingTaiMer68Devices, JingTaiMg75Devices, RoYuanDeviceList, RoYuanDeviceList_0005 } from './device_vendor'
import { speciaBehiver, specialCheckCurrent } from './limit'
import { DeviceManager } from '@/service/device'

interface QuickTriggerParam {
  IsEnableBoth: boolean
  Press: number
  Release: number
}

const defaultQuickTriggerTravel: QuickTriggerParam = { IsEnableBoth: false, Press: 5, Release: 5 }

const royuanMagnetTravel = { IsEnableBoth: true, Press: 50, Release: 50 }
const deviceMagnetTravel: Map<DevicePid, QuickTriggerParam> = new Map([
  [DevicePid.IROKNa87Pro, { IsEnableBoth: true, Press: 500, Release: 500 }],
  [DevicePid.IYXMu68Pro, { IsEnableBoth: true, Press: 500, Release: 500 }],
  [DevicePid.IYXMu68Pro_cyan, { IsEnableBoth: true, Press: 500, Release: 500 }],
  [DevicePid.IYXMu68_ULTRA, { IsEnableBoth: true, Press: 500, Release: 500 }],
  [DevicePid.IROKNd63, { IsEnableBoth: true, Press: 500, Release: 500 }],
  [DevicePid.IROKNd63_cyan, { IsEnableBoth: true, Press: 500, Release: 500 }],
  [DevicePid.IYXPolar75, { IsEnableBoth: true, Press: 5, Release: 5 }],
])
RoYuanDeviceList.forEach((element) => deviceMagnetTravel.set(element, royuanMagnetTravel))
RoYuanDeviceList_0005.forEach((element) => deviceMagnetTravel.set(element, { IsEnableBoth: true, Press: 200, Release: 200 }))

JingTaiMer68Devices.forEach((element) => deviceMagnetTravel.set(element, { IsEnableBoth: true, Press: 5, Release: 5 }))
JingTaiMg75Devices.forEach((element) => deviceMagnetTravel.set(element, { IsEnableBoth: true, Press: 5, Release: 5 }))
JingTaiV2DeviceList.forEach((element) => deviceMagnetTravel.set(element, { IsEnableBoth: true, Press: 3, Release: 3 }))
deviceMagnetTravel.set(DevicePid.CarotmasMer68SE_JT, { IsEnableBoth: true, Press: 10, Release: 10 })
export const deviceQuickTriggerTravel = (pid: DevicePid) => deviceMagnetTravel.get(pid) || defaultQuickTriggerTravel

/**
 * 行程配置数据
 * */
export const travelConfig = (pid: DevicePid) => getFirmwareTravelConfig(pid) || travelConfigMap.get(pid) || defaultTravelConfig
interface TravelInfo {
  unit: number //换算单位
  decimalPlaces: number //保留小数位
  maxTravel: number //最大行程
  minTravel?: number //最小行程  20250327 新增
  quickTriggerPressMaxTravel?: number //快速触发按下最大行程  20250327 新增
  quickTriggerPressMinTravel?: number //快速触发按下最小行程  20250327 新增
  quickTriggerPressStep?: number //快速触发按下步进  20250327 新增

  quickTriggerReleaseMaxTravel?: number //快速触发松开最大行程  20250327 新增
  quickTriggerReleaseMinTravel?: number //快速触发松开最小行程  20250327 新增
  quickTriggerReleaseStep?: number //快速触发松开步进  20250327 新增

  defaultTravel: number //默认行程
  step: number
  deadZone: number[]
  defaultDeadZone: {
    //默认死区
    top: number
    bottom: number
  }
  deadZoneLimit?: number[] // 死区限制 [ topMinZone, topMaxZone, bottomMinZone, bottomMaxZone ]
  deadZoneStep?: number // 死区步长  20250327 新增
}

// 普通磁轴键盘没有死区
const defaultTravelConfig = {
  unit: 10,
  decimalPlaces: 1,
  maxTravel: 40,
  minTravel: 40 / 40,
  quickTriggerPressMaxTravel: 40,
  quickTriggerPressMinTravel: 40 / 40,
  quickTriggerPressStep: 40,
  quickTriggerReleaseMaxTravel: 40,
  quickTriggerReleaseMinTravel: 40 / 40,
  quickTriggerReleaseStep: 40,
  defaultTravel: 20,
  step: 40,
  deadZone: [],
  defaultDeadZone: { top: 0, bottom: 0 },
  deadZoneStep: 1,
  deadZoneLimit: [0, 0, 0, 0],
}
const mars68TravelConfig = {
  unit: 100,
  decimalPlaces: 2,
  maxTravel: 350,
  minTravel: 350 / 350, // 0.01
  quickTriggerPressMaxTravel: 300,
  quickTriggerPressMinTravel: 300 / 300,
  quickTriggerPressStep: 300,
  quickTriggerReleaseMaxTravel: 300,
  quickTriggerReleaseMinTravel: 300 / 300,
  quickTriggerReleaseStep: 300,
  defaultTravel: 200,
  step: 350,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 30, bottom: 30 },
  deadZoneStep: 1,
}

const travel0005Config = {
  unit: 1000,
  decimalPlaces: 3,
  maxTravel: 3500,
  minTravel: 5,
  defaultTravel: 2000,
  step: 3500,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 200, bottom: 200 },
  deadZoneStep: 10,
}
const travel0004Config = {
  unit: 1000,
  decimalPlaces: 3,
  maxTravel: 3500,
  minTravel: 4,
  defaultTravel: 2000,
  step: 3500,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 200, bottom: 200 },
  deadZoneStep: 10,
}
const travelPolarConfig = {
  unit: 1000,
  decimalPlaces: 3,
  maxTravel: 3300,
  minTravel: 1,
  defaultTravel: 2000,
  step: 3300,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 200, bottom: 200 },
  deadZoneStep: 1,
}

const travelJingtaiV2Config = {
  unit: 1000,
  decimalPlaces: 3,
  maxTravel: 3500,
  minTravel: 1,
  defaultTravel: 2000,
  step: 3500,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 200, bottom: 200 },
  deadZoneStep: 1,
}

const travelMer68SEJTConfig = {
  ...travelJingtaiV2Config,
  defaultTravel: 1500,
  decimalPlaces: 2,
  minTravel: 10, // 0.01 mm
  step: 350,
}

const travelRYuanACEConfig = {
  unit: 1000,
  decimalPlaces: 3,
  maxTravel: 3500,
  minTravel: 3500 / 700, // 0.005
  quickTriggerPressMaxTravel: 3000,
  quickTriggerPressMinTravel: 5,
  quickTriggerPressStep: 3000 / 5,
  quickTriggerReleaseMaxTravel: 3000,
  quickTriggerReleaseMinTravel: 5,
  quickTriggerReleaseStep: 3000 / 5,
  defaultTravel: 2000,
  step: 700,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 300, bottom: 300 },
  deadZoneStep: 1,
}

const travelMer68SESelfDevConfig = {
  unit: 1000,
  decimalPlaces: 3,
  maxTravel: 3350,
  minTravel: 1,
  defaultTravel: 2000,
  step: 3350,
  deadZone: [0, 40, 60, 80, 120, 160],
  defaultDeadZone: { top: 200, bottom: 200 },
  deadZoneStep: 10,
}

const travelHuochairenConfig = { unit: 1000, decimalPlaces: 3, maxTravel: 3400, minTravel: 1, defaultTravel: 1500, step: 3400, deadZoneStep: 1, deadZoneLimit: [0, 200, 0, 200], deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 0, bottom: 0 } }
const travelHuochairen3500Config = { ...travelHuochairenConfig, maxTravel: 3500, step: 3500 }

const travelFe87V2Config = { unit: 1000, decimalPlaces: 3, maxTravel: 3550, minTravel: 200, defaultTravel: 1500, step: 3550, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 }, deadZoneLimit: [0, 1000, 0, 1000] }

const getFirmwareTravelConfig = (pid: DevicePid): TravelInfo | undefined => {
  const fwVersion = firmware.cachedFirmwareVersion
  if (!fwVersion) {
    return undefined
  }

  if (pid === DevicePid.IROKMG63 && compare(fwVersion, '1.13', '>=')) {
    return travelHuochairen3500Config
  }

  if (pid === DevicePid.IROKRA68_1 && compare(fwVersion, '1.13', '>')) {
    return travelHuochairen3500Config
  }

  if (pid === DevicePid.IROKMG75V2C12 && compare(fwVersion, '1.06', '>=')) {
    return travelHuochairen3500Config
  }

  return undefined
}

const travelConfigMap = new Map<DevicePid, TravelInfo>()
travelConfigMap.set(DevicePid.IYXMu68Pro, { unit: 1000, decimalPlaces: 2, maxTravel: 4000, defaultTravel: 2000, step: 200, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 } })
travelConfigMap.set(DevicePid.IROKNd63, { unit: 1000, decimalPlaces: 2, maxTravel: 4000, defaultTravel: 2000, step: 200, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 } })
travelConfigMap.set(DevicePid.IYXMu68Pro_cyan, { unit: 1000, decimalPlaces: 2, maxTravel: 3600, defaultTravel: 2000, step: 180, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 } })
travelConfigMap.set(DevicePid.IYXMu68_ULTRA, { unit: 1000, decimalPlaces: 2, maxTravel: 3500, defaultTravel: 2000, step: 350, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 } })
travelConfigMap.set(DevicePid.IROKNd63_cyan, { unit: 1000, decimalPlaces: 2, maxTravel: 3600, defaultTravel: 2000, step: 180, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 } })
travelConfigMap.set(DevicePid.IROKNa87Pro, { unit: 1000, decimalPlaces: 3, maxTravel: 4000, defaultTravel: 2000, step: 200, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 } })

travelConfigMap.set(DevicePid.IrokFe87V2IMC, travelFe87V2Config)
travelConfigMap.set(DevicePid.IrokFe87V2IMC_24g, travelFe87V2Config)

travelConfigMap.set(DevicePid.IROKMG63, travelHuochairenConfig)
travelConfigMap.set(DevicePid.IROKRA68_1, travelHuochairenConfig)
travelConfigMap.set(DevicePid.IROKMG75V2C12, travelHuochairenConfig)

RoYuanDeviceList.forEach((id) => travelConfigMap.set(id, mars68TravelConfig))
RoYuanDeviceList_0005.forEach((id) => travelConfigMap.set(id, travelRYuanACEConfig))
JingTaiMg75Devices.forEach((id) => travelConfigMap.set(id, travel0005Config))
JingTaiMer68Devices.forEach((id) => travelConfigMap.set(id, travel0004Config))
travelConfigMap.set(DevicePid.IYXPolar75, travelPolarConfig)
JingTaiV2DeviceList.forEach((id) => travelConfigMap.set(id, travelJingtaiV2Config))
travelConfigMap.set(DevicePid.CarotmasMer68SE_JT, travelMer68SEJTConfig)
travelConfigMap.set(DevicePid.CarotmasMer68SESelfDev, travelMer68SESelfDevConfig)

export const getTravelStep = async () => {
  if (specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V1)) {
    const fwVersionIs104 = await firmware.fwVersionGreaterThanOrEqual('1.0.4', firmware.fwVersionDvs1)
    const fwVersionIs100 = await firmware.fwVersionGreaterThanOrEqual('1.0.0', firmware.fwVersionDvs2)
    const fwVersion20250326 = await firmware.versionIs20250326()

    if (fwVersionIs104 || fwVersionIs100 || fwVersion20250326) {
      return travelConfig(DeviceManager.instance.state.currentPid).step
    }
    return 100
  }

  if (travelConfig(DeviceManager.instance.state.currentPid).step) {
    return travelConfig(DeviceManager.instance.state.currentPid).step
  }
  return 100
}

export const travelFe87V2FWGT212Config = { unit: 1000, decimalPlaces: 3, maxTravel: 3550, minTravel: 300, defaultTravel: 1500, step: 3550, deadZone: [0, 40, 60, 80, 120, 160], defaultDeadZone: { top: 200, bottom: 200 }, deadZoneLimit: [0, 1000, 0, 1000] }
